// extracted by mini-css-extract-plugin
module.exports = {"logo":"About_logo__1Kx8G","about":"About_about__1kqer","icons":"About_icons__VKV0X"};